import { render, staticRenderFns } from "./TheEmail.vue?vue&type=template&id=42923387&scoped=true"
import script from "./TheEmail.vue?vue&type=script&lang=js"
export * from "./TheEmail.vue?vue&type=script&lang=js"
import style0 from "./TheEmail.vue?vue&type=style&index=0&id=42923387&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42923387",
  null
  
)

export default component.exports